import React, { createContext } from 'react';

export const CartContext = createContext();

export const useCart = () => {
  const context = React.useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartContext.Provider');
  }
  return context;
};
